import { render, staticRenderFns } from "./PanelSection.vue?vue&type=template&id=1148ce3a&scoped=true"
import script from "./PanelSection.vue?vue&type=script&lang=js"
export * from "./PanelSection.vue?vue&type=script&lang=js"
import style0 from "./PanelSection.vue?vue&type=style&index=0&id=1148ce3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1148ce3a",
  null
  
)

export default component.exports